var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalyticswhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.9165 17.2446H5.43502V12.6798H1.9165V17.2446ZM2.9628 13.7169H4.38873V16.1984H2.9628V13.7169ZM6.30539 17.2261H9.73132V7.42983H6.30539V17.2261ZM7.35169 8.46687H8.68502V16.1891H7.35169V8.46687ZM10.6295 17.2261H13.898V10.5502H10.6295V17.2261ZM11.6758 11.5965H12.8795V16.2261H11.6758V11.5965ZM14.9072 8.58724V17.1706H18.3332V8.58724H14.9072ZM17.2961 16.1243H15.9535V9.64279H17.2961V16.1243ZM2.48132 10.7354L1.6665 10.078L7.57391 2.75391L12.5461 7.76316L17.6572 3.67983L18.2961 4.50391L12.4628 9.13354L7.65725 4.27242L2.48132 10.7354Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticswhite);
export default __webpack_public_path__ + "static/media/analytics white.eb6a0ac265d740980fbdb25c86c429a8.svg";
export { ForwardRef as ReactComponent };